/* eslint-disable no-empty */
/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
import { Route, Routes, Navigate, Outlet } from 'react-router-dom';
import { useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import SpinnerPage from './components/SpinnerPage/SpinnerPage';
import { loadLocale, me } from './actions';
import FlashcardsView from './pages/FlashcardsView/FlashcardsView';
import QuestionsLearningView from './pages/QuestionsLearningView/QuestionsLearningView';
import Sliders from './pages/Sliders/Sliders';
import Slider from './pages/Slider/Slider';
import SliderView from './pages/SliderView/SliderView';
import { GoogleOAuthProvider } from '@react-oauth/google';
import config from './config';

const Login = React.lazy(() => import('./pages/Login/Login'));
const DeleteAccount = React.lazy(() => import('./pages/DeleteAccount/DeleteAccount'));
const Verify = React.lazy(() => import('./pages/Verify/Verify'));
const Dashboard = React.lazy(() => import('./pages/Dashboard/Dashboard'));
const Questions = React.lazy(() => import('./pages/Questions/Questions'));
const Register = React.lazy(() => import('./pages/Register/Register'));
const Layout = React.lazy(() => import('./pages/Layout/Layout'));
const Translate = React.lazy(() => import('./pages/Translate/Translate'));
const Profile = React.lazy(() => import('./pages/Profile/Profile'));
const Classrooms = React.lazy(() => import('./pages/Classrooms/Classrooms'));
const Students = React.lazy(() => import('./pages/Students/Students'));
const StatisticReport = React.lazy(() => import('./pages/StatisticReport/StatisticReport'));
const Quizs = React.lazy(() => import('./pages/Quizs/Quizs'));
const Quiz = React.lazy(() => import('./pages/Quiz/Quiz'));
const Flashcards = React.lazy(() => import('./pages/Flashcards/Flashcards'));
const QuestionsLearning = React.lazy(() => import('./pages/QuestionsLearning/QuestionsLearning'));
const Presentations = React.lazy(() => import('./pages/Presentations/Presentations'));
const PresentationStart = React.lazy(() => import('./pages/PresentationStart/PresentationStart'));
const Presentation = React.lazy(() => import('./pages/Presentation/Presentation'));
const QuestionsView = React.lazy(() => import('./pages/QuestionsView/QuestionsView'));
const AdminPanel = React.lazy(() => import('./pages/AdminPanel/AdminPanel'));
const QuestionsTrashed = React.lazy(() => import('./pages/QuestionsTrashed/QuestionsTrashed'));
const FlashcardsTrashed = React.lazy(() => import('./pages/FlashcardsTrashed/FlashcardsTrashed'));
const QuestionsImport = React.lazy(() => import('./pages/QuestionsImport/QuestionsImport'));
const QuestionsShared = React.lazy(() => import('./pages/QuestionsShared/QuestionsShared'));
const Forgot = React.lazy(() => import('./pages/Forgot/Forgot'));
const Reset = React.lazy(() => import('./pages/Reset/Reset'));
const StudentRoomQueze = React.lazy(() => import('./pages/Student/Quizs/Quizs'));
const StudentQuezStatistic = React.lazy(() => import('./pages/Student/QuizStatistic/QuizStatistic'));
const StudentQuestions = React.lazy(() => import('./pages/Student/Questions/Questions'));


export const routers = [
  { path: '/dashboard', element: <Dashboard />, role: "any" },
  { path: '/questions', element: <Questions />, role: "any" },
  { path: '/questions/import', element: <QuestionsImport />, role: "any" },
  { path: '/questions/trashed', element: <QuestionsTrashed />, role: "any" },
  { path: '/questions/shared', element: <QuestionsShared />, role: "any" },
  { path: '/flashcards/trashed', element: <FlashcardsTrashed />, role: "any" },
  { path: '/profile', element: <Profile />, role: "any" },
  // { path: '/translate', element: <Translate />, role: "any" },
  // { path: '/classrooms', element: <Classrooms />, role: "any" },
  // { path: '/students', element: <Students />, role: "any" },
  // { path: '/statistic_reports', element: <StatisticReport />, role: "any" },
  // { path: '/quizs', element: <Quizs />, role: "any" },
  { path: '/flashcards', element: <Flashcards />, role: "any" },
  { path: '/active-learning', element: <QuestionsLearning />, role: "any" },
  { path: '/presentations', element: <Presentations />, role: "any" },
  { path: '/sliders', element: <Sliders />, role: "any" },
  // { path: '/quizs/:id', element: <Quiz />, role: "any" },
  { path: '/presentations_start/:id', element: <PresentationStart />, role: "any" },
  { path: '/presentation/:id', element: <Presentation />, role: "any" },
  { path: '/slider/:id', element: <Slider />, role: "any" },
  { path: '/admin-panels', element: <AdminPanel />, role: "admin" },
  // { path: '/rooms/:id', element: <StudentRoomQueze />, role: "any" },
  // { path: '/quiz-statistic/:id', element: <StudentQuezStatistic />, role: "any" },
  // { path: '/quiz/:id', element: <StudentQuestions />, role: "any" },
];

function Routers() {
  const role = useSelector(state => state.auth.role)
  const isLogined = useSelector((state) => state.auth.isLogined);

  const dispatch = useDispatch();
  // useEffect(() => {
  //   console.log('dddd')
  //   dispatch(me());
  // }, []);

  return (
    // <Router history={history}>
    <React.Suspense fallback={<SpinnerPage />}>
      <Routes>
        <Route element={<PublicPages />}>
          <Route path="/slider/view/:id" element={<SliderView />} />
          <Route path="/delete-account/:code" element={<DeleteAccount />} />
          <Route path="/questions/view/:id" element={<QuestionsView />} />
          <Route path="/question/view/:id" element={<QuestionsView />} />
          <Route path="/flashcards/view/:id" element={<FlashcardsView />} />
          <Route path="/cards/view/:id" element={<FlashcardsView />} />
          <Route path="/questions/learning/view/:id" element={<QuestionsLearningView />} />
          <Route path="/question_multy/view/:id" element={<QuestionsLearningView />} />
        </Route>
        <Route element={<Layout />}>
          <Route path="/" element={<RequireAuth />}>
            {routers.filter(_i => isLogined).map((_i) => (
              <Route key={_i.path} path={_i.path} element={_i.element} />
            ))}
            <Route path="*" to="/dashboard" />
          </Route>
          <Route path="/" element={<RequireNotAuth />}>
            <Route path="login" element={<GoogleOAuthProvider clientId={config.googleClientId}><Login /></GoogleOAuthProvider>} />
            <Route path="forgot" element={<Forgot />} />
            <Route path="register" element={<GoogleOAuthProvider clientId={config.googleClientId}><Register /></GoogleOAuthProvider>} />
            <Route path="signup" element={<GoogleOAuthProvider clientId={config.googleClientId}><Register /></GoogleOAuthProvider>} />
            <Route path="reset/:code" element={<Reset />} />
            <Route path="verify/:id" element={<Verify />} />
            {/* <Route path="register/:role" element={<RegisterRole />}  />
            <Route path="login/admin" element={<Login isAdmin />} />
            <Route path="forgot" element={<Forgot />} />
            <Route path="reset/:code" element={<Reset />} />
            <Route path="invitegroup/:id" element={<Invitegroup />} /> */}
          </Route>
        </Route>
      </Routes>
    </React.Suspense>
    // </Router>
  );
}

// These routes are outside Layout, so me() does not load translations for them
function PublicPages() {
  const dispatch = useDispatch();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    dispatch(loadLocale())
      .catch((error) => console.log("🚀 ~ PublicPages ~ error:", error))
      .finally(() => setReady(true));
  }, []);

  if (!ready) {
    return <SpinnerPage />;
  }

  return <Outlet />;
}

function RequireAuth({ children }) {
  const location = useLocation();
  const isLogined = useSelector((state) => state.auth.isLogined);
  if (!isLogined) {
    return <Navigate to="/login" state={{ from: location }} />;
  }


  if (location.pathname == '/') {
    return <Navigate to="/login" state={{ from: location }} />;
  }
  return <Outlet />;
}

function RequireNotAuth({ children }) {
  const location = useLocation();
  const isLogined = useSelector((state) => state.auth.isLogined);
  if (isLogined) {
    let to = '/dashboard';
    return <Navigate to={to} state={{ from: location }} />;
  }

  return <Outlet />;
}

export default Routers;
